var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderLabels',{attrs:{"labels":_vm.labels},on:{"update":_vm.updateField}})}
var staticRenderFns = []

export { render, staticRenderFns }